// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"SourcingCta__wrapper__6caca3ca","headline":"SourcingCta__headline__6caca3ca","cta":"SourcingCta__cta__6caca3ca"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/newPdp/components/SourcingCta/SourcingCta.scss
// module id = 3433
// module chunks = 7